import { clearLegacyRoutePolylines } from "../map-elements/helper";
import { TMapRef } from "../type";


export const clearLegacyMapLayer = (
  mapRef: React.MutableRefObject<TMapRef>
) => {
  clearLegacyRoutePolylines();

  const objects = mapRef.current?.objects;
  if (!objects) return;

  objects.mPushpins?.forEach((pushpin) => {
    const marker = pushpin?.marker;
    if (!marker) return;
    if (typeof marker.setMap === "function") marker.setMap(null);
    else marker.map = null;
  });

  objects.mTripsData?.forEach((tripData) => {
    Object.values(tripData.views || {}).forEach((view: any) => {
      view?.mapElements?.forEach((element: any) => element?.setMap?.(null));
      const instanceElements = view?.classObject?.mapElements;
      if (Array.isArray(instanceElements)) {
        instanceElements.forEach((element: any) => element?.setMap?.(null));
      } else {
        instanceElements?.setMap?.(null);
      }
    });
  });
};
